import { render, staticRenderFns } from "./relationPres.vue?vue&type=template&id=7c377398&scoped=true"
import script from "./relationPres.vue?vue&type=script&lang=ts"
export * from "./relationPres.vue?vue&type=script&lang=ts"
import style0 from "./relationPres.vue?vue&type=style&index=0&id=7c377398&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c377398",
  null
  
)

export default component.exports